export const stepListTranslations = {
  en: {
    stepListTitle: "Step List",
    addPackageButton: "+ Add Package",
    stepsButton: "Steps",
    typeLabel: "Type",
    searchPlaceholder: "Search",
    addStepButton: "+ Add Step",
    name: "Name",
    package: "Package",
    deleteStepConfirmation:
      'Are you sure you want to delete the step "{label}"?',
  },
  ru: {
    stepListTitle: "Список шагов",
    addPackageButton: "+ Добавить пакет",
    stepsButton: "Шаги",
    typeLabel: "Тип",
    searchPlaceholder: "Поиск",
    addStepButton: "+ Добавить шаг",
    name: "Название",
    package: "Пакет",
    deleteStepConfirmation: 'Вы уверены, что хотите удалить шаг "{label}"?',
  },
  cz: {
    stepListTitle: "Seznam kroků",
    addPackageButton: "+ Přidat balíček",
    stepsButton: "Kroky",
    typeLabel: "Typ",
    searchPlaceholder: "Hledat",
    addStepButton: "+ Přidat krok",
    name: "Název",
    package: "Balíček",
    deleteStepConfirmation: 'Opravdu chcete smazat krok "{label}"?',
  },
  sk: {
    stepListTitle: "Zoznam krokov",
    addPackageButton: "+ Pridať balík",
    stepsButton: "Kroky",
    typeLabel: "Typ",
    searchPlaceholder: "Hľadať",
    addStepButton: "+ Pridať krok",
    name: "Meno",
    package: "Balík",
    deleteStepConfirmation: 'Naozaj chcete odstrániť krok "{label}"?',
  },
  de: {
    stepListTitle: "Schrittliste",
    addPackageButton: "+ Paket hinzufügen",
    stepsButton: "Schritte",
    typeLabel: "Typ",
    searchPlaceholder: "Suche",
    addStepButton: "+ Schritt hinzufügen",
    name: "Name",
    package: "Paket",
    deleteStepConfirmation:
      'Sind Sie sicher, dass Sie das schritt "{label}" löschen möchten?',
  },
  hu: {
    stepListTitle: "Lépéslista",
    addPackageButton: "+ Csomag hozzáadása",
    stepsButton: "Lépések",
    typeLabel: "Típus",
    searchPlaceholder: "Keresés",
    addStepButton: "+ Lépés hozzáadása",
    name: "Név",
    package: "Csomag",
    deleteStepConfirmation: 'Biztos benne, hogy törli a lépés "{label}"?',
  },
  pl: {
    stepListTitle: "Lista kroków",
    addPackageButton: "+ Dodaj pakiet",
    stepsButton: "Kroki",
    typeLabel: "Typ",
    searchPlaceholder: "Szukaj",
    addStepButton: "+ Dodaj krok",
    name: "Nazwa",
    package: "Pakiet",
    deleteStepConfirmation: 'Czy na pewno chcesz usunąć krok "{label}"?',
  },
  fr: {
    stepListTitle: "Liste des étapes",
    addPackageButton: "+ Ajouter un paquet",
    stepsButton: "Étapes",
    typeLabel: "Type",
    searchPlaceholder: "Rechercher",
    addStepButton: "+ Ajouter une étape",
    name: "Nom",
    package: "Paquet",
    deleteStepConfirmation:
      'Voulez-vous vraiment supprimer l\'étape "{label}"?',
  },
  es: {
    stepListTitle: "Lista de pasos",
    addPackageButton: "+ Añadir paquete",
    stepsButton: "Pasos",
    typeLabel: "Tipo",
    searchPlaceholder: "Buscar",
    addStepButton: "+ Añadir paso",
    name: "Nombre",
    package: "Paquete",
    deleteStepConfirmation:
      '¿Estás seguro de que deseas eliminar el paso "{label}"?',
  },
  nl: {
    stepListTitle: "Lijst van stappen",
    addPackageButton: "+ Pakket toevoegen",
    stepsButton: "Stappen",
    typeLabel: "Type",
    searchPlaceholder: "Zoeken",
    addStepButton: "+ Stap toevoegen",
    name: "Naam",
    package: "Pakket",
    deleteStepConfirmation:
      'Weet u zeker dat u de stap "{label}" wilt verwijderen?',
  },
  sv: {
    stepListTitle: "Steglista",
    addPackageButton: "+ Lägg till paket",
    stepsButton: "Steg",
    typeLabel: "Typ",
    searchPlaceholder: "Sök",
    addStepButton: "+ Lägg till steg",
    name: "Namn",
    package: "Paket",
    deleteStepConfirmation:
      'Är du säker på att du vill ta bort steget "{label}"?',
  },
  no: {
    stepListTitle: "Stegliste",
    addPackageButton: "+ Legg til pakke",
    stepsButton: "Steg",
    typeLabel: "Type",
    searchPlaceholder: "Søk",
    addStepButton: "+ Legg til steg",
    name: "Navn",
    package: "Pakke",
    deleteStepConfirmation:
      'Er du sikker på at du vil slette steget "{label}"?',
  },
  da: {
    stepListTitle: "Trinliste",
    addPackageButton: "+ Tilføj pakke",
    stepsButton: "Trin",
    typeLabel: "Type",
    searchPlaceholder: "Søg",
    addStepButton: "+ Tilføj trin",
    name: "Navn",
    package: "Pakke",
    deleteStepConfirmation:
      'Er du sikker på, at du vil slette trinet "{label}"?',
  },
  fi: {
    stepListTitle: "Vaihelista",
    addPackageButton: "+ Lisää paketti",
    stepsButton: "Vaiheet",
    typeLabel: "Tyyppi",
    searchPlaceholder: "Hae",
    addStepButton: "+ Lisää vaihe",
    name: "Nimi",
    package: "Paketti",
    deleteStepConfirmation:
      'Oletko varma, että haluat poistaa vaiheen "{label}"?',
  },
  ar: {
    stepListTitle: "قائمة الخطوات",
    addPackageButton: "+ إضافة حزمة",
    stepsButton: "الخطوات",
    typeLabel: "النوع",
    searchPlaceholder: "بحث",
    addStepButton: "+ إضافة خطوة",
    name: "الاسم",
    package: "الحزمة",
    deleteStepConfirmation: 'هل أنت متأكد أنك تريد حذف الخطوة "{label}"؟',
  },
};

export default stepListTranslations;
